module.exports = __webpack_public_path__ + "img/1.522e6b55.png";